import React, { useState } from 'react';

const EmailVerification = () => {
  const [step, setStep] = useState(1);
  const [email, setEmail] = useState('');
  const [token, setToken] = useState('');
  const [message, setMessage] = useState('');

  const handleSendToken = async () => {
    setMessage('');
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/email/send-verification`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });

      const data = await res.json();

      if (res.ok) {
        setMessage('✅ Token enviado. Revisá tu correo.');
        setStep(2);
      } else {
        setMessage(`❌ ${data.error || 'No se pudo enviar el token.'}`);
      }
    } catch (error) {
      console.error(error);
      setMessage('❌ Error de conexión con el servidor.');
    }
  };

  const handleVerifyToken = async () => {
    setMessage('');
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/email/verify-token`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, token }),
      });

      const data = await res.json();

      if (res.ok) {
        setMessage('✅ Verificación exitosa. Ya podés continuar.');
      } else {
        setMessage(`❌ ${data.error || 'Token inválido o expirado.'}`);
      }
    } catch (error) {
      console.error(error);
      setMessage('❌ Error de conexión con el servidor.');
    }
  };

  return (
    <div style={{ maxWidth: 400, margin: 'auto', padding: 20 }}>
      <h2>Verificación de correo</h2>

      {step === 1 && (
        <>
          <input
            type="email"
            placeholder="Tu correo"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            style={{ width: '100%', marginBottom: 10, padding: 8 }}
          />
          <button onClick={handleSendToken} style={{ width: '100%', padding: 10 }}>
            Enviar código
          </button>
        </>
      )}

      {step === 2 && (
        <>
          <input
            type="text"
            placeholder="Código recibido"
            value={token}
            onChange={(e) => setToken(e.target.value)}
            style={{ width: '100%', marginBottom: 10, padding: 8 }}
          />
          <button onClick={handleVerifyToken} style={{ width: '100%', padding: 10 }}>
            Verificar código
          </button>
        </>
      )}

      {message && <p style={{ marginTop: 15 }}>{message}</p>}
    </div>
  );
};

export default EmailVerification;